<!--TODO revise class names-->
<cmps-dialog>
    <div class="container mt-3">
        <div class="row">
            <div class="col-12 text-center">
                <h4>
                    {{
                        _i18n._9517_PLEASE_SELECT_DISPOSITION_REASON_BEFORE_PROCEEDING
                            | translate
                    }}
                </h4>
            </div>
        </div>
        <div
            class="col-12 p-0"
            [formGroup]="_form.form"
        >
            <div class="flex-item mt-1 mb-1">
                <ng-select
                    class="w-auto"
                    [options]="_dispositionReasonsOpts"
                    [noFilter]="999"
                    [placeholder]="_form.fields.REASON.placeholder | translate"
                    [formControlName]="_form.fields.REASON.name"
                ></ng-select>
                <div
                    class="required"
                    *ngIf="_form.errors['REASON']"
                >
                    {{ _form.errors['REASON'] }}
                </div>
            </div>
            <div class="flex-item">
                <div class="flex-column">
                    <div class="flex-item mt-1 mb-1">
                        <div
                            cmpsNoteDetailNext
                            [formControlName]="_form.fields.COMMENT.name"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-center mb-2">
        <button
            cmpsButton
            (click)="_onSubmitClick()"
        >
            <cmps-icon svgIcon="email-outline"></cmps-icon>
            <span cmpsButtonLabel>{{
                _i18n._9518_SEND_MY_DISPOSITION | translate
            }}</span>
        </button>
    </div>
</cmps-dialog>
